import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { GoogleMap, Circle } from "@react-google-maps/api";
import { googleMapLoader } from '../../../helpers/googleMapLoader';
import cx from 'classnames';

import messages from '../../../locale/messages';
import { DARK_SECONDARY_COLOR, SECONDARY_COLOR } from '../../../constants'
import { mapThemeStyle } from '../../../helpers/mapThemeStyle';
import s from './LocationMap.css';

const containerStyle = {
  width: '100%',
  height: '100%',
  borderRadius: 24,
};
const LocationMap = ({ data }) => {

  const theme = useSelector(state => state.currency.theme);
  const googleMapBrowserApiKey = useSelector(state => state?.encodeConfigSettings?.googleMapBrowserApiKey);
  const prevTheme = useRef(theme);
  const mapCircleBg = theme === 'dark' ? DARK_SECONDARY_COLOR : SECONDARY_COLOR;

  const [center, setCenter] = useState({});
  const [markers, setMarkers] = useState(null);
  const [googleMapsApiLoaded, setGoogleMapsApiLoaded] = useState(false);
  const [styles, setStyles] = useState([
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{
        color: '#a4ddf5'
      }]
    }
  ]);

  useEffect(() => {
    const initialize = async () => {
      setStyles(mapThemeStyle(theme));
      await googleMapLoader(googleMapBrowserApiKey);
      setGoogleMapsApiLoaded(true);
      if (theme !== prevTheme) {
        setStyles(mapThemeStyle(theme));
      }

      const lat = Number(data.lat);
      const lng = Number(data.lng);

      setCenter({ lat, lng });
    };

    initialize();
  }, []);

  const handleOnLoad = (map) => {
    const markers = [{
      position: new google.maps.LatLng(center.lat, center.lng)
    }];
    const bounds = new google.maps.LatLngBounds();
    markers.forEach(({ position }) => bounds.extend(position));
    map.fitBounds(bounds);
  };


  let firstName, city, state, country;
  firstName = data.user.profile.firstName;
  city = data.city;
  state = data.state ? String(data.state).trim() : '';
  country = data.country === 'BO' ? 'Bolivia': data.country;
  const locationName = [city, state, country].filter(Boolean).join(', ');

  return (
    <div>
      <div className={cx(s.space2)}>
        <p className={cx(s.titleText, s.space2)}>
          <FormattedMessage {...messages.location} />
        </p>
        <div style={{ height: 500 }} className='viewListingMapResultContainer'>
          {
            googleMapsApiLoaded ?
              <GoogleMap
                mapContainerStyle={containerStyle}
                defaultZoom={10}
                center={center}
                onLoad={handleOnLoad}
                clickableIcons={false}
                options={{
                  backgroundColor: '',
                  scrollwheel: false,
                  maxZoom: 16,
                  minZoom: 10,
                  borderRadius: '15px',
                  streetViewControl: false,
                  zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP
                  },
                  mapTypeControl: false,
                  styles: styles
                }}
              >
                <Circle
                  center={center}
                  radius={200}
                  options={{
                    fillColor: mapCircleBg,
                    strokeColor: mapCircleBg
                  }}
                />
              </GoogleMap>
              :
              <></>
          }
        </div>
       {/*  <div className={cx(s.locationSmallText)}><FormattedMessage {...messages.neighborhoodInfo} /></div> */}
        <div className={cx(s.locationNameCss)}>{locationName}</div>
        <div className={s.listingLine}></div>
      </div>
    </div>
  );
}

LocationMap.propTypes = {
  data: PropTypes.object,
  formatMessage: PropTypes.any,
};

export default withStyles(s)(LocationMap);
